import { namedEntities } from "./namedEntities.js";
/**
 * Converts a string to title-case.
 *
 * @param string The text to convert to title-case
 * @returns The text in title-case
 */
export function toTitleCase(string) {
    if (string.length === 0) {
        return string;
    }
    return handleSplitter(handleSplitter(string.toLowerCase(), " "), "\n");
}
/**
 * Converts a string to sentence-case, for a given splitter.
 *
 * @param string The text to convert to sentence-case
 * @param splitter The character to split the string by
 * @returns The text in sentence-case
 */
function handleSplitter(string, splitter) {
    const sentence = string.split(splitter);
    for (let i = 0; i < sentence.length; i++) {
        if (sentence[i].length === 0) {
            continue;
        }
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(splitter);
}
/**
 * Decode HTML entities in a string.
 *
 * @example
 * 	decodeHTMLEntities("That&#39;s cool!"); // => "That's cool!"
 * 	decodeHTMLEntities("&lt;div&gt;"); // => "<div>" Note that this should be used with caution, as it can be a security risk.
 *
 * @param string The string to decode
 * @returns The decoded string
 */
export function decodeHTMLEntities(string) {
    let str = string.replace(/&#(\d+);/g, (_, dec) => {
        return String.fromCharCode(dec);
    });
    for (const [key, value] of Object.entries(namedEntities)) {
        str = str.replace(new RegExp(`&${key};`, "g"), value);
    }
    return str;
}
//# sourceMappingURL=string.js.map